import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { getRole } from "../utils/GetRole";

const ProtectedRoute = () => {
  const authUser = localStorage.getItem("authUser");
  const role = getRole(); // "admin", "artist", or "user"
  const location = useLocation();

  if (!authUser) {
    return <Navigate to="/login" replace />;
  }

  const path = location.pathname;

  const roleBasePath = {
    admin: "/admin",
    artist: "/artist",
    user: "/user",
  };

  const allowedPath = roleBasePath[role];

  // 🚫 If not authorized for this section, redirect
  if (!path.startsWith(allowedPath)) {
    return <Navigate to={allowedPath} replace />;
  }

  // ✅ Otherwise, render the actual component
  return <Outlet />;
};

export default ProtectedRoute;
